import {LitElement, html, css} from 'lit';
import {msg} from '@lit/localize';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';
import {getProductData} from '../../../util/getProductData';
import {luminaryOptions} from '../../../sectionConfig';
import {selectProductModelId} from '../../../selectors';

@customElement('visual-lightprofile-summary-lamps-luminary-grid')
export class VisualLightprofileSummaryLampsLuminaryGrid extends connect(store)(LitElement) {

	static styles = [
		css`
		.LampsAndColors {
			padding: 100px 30px 100px 30px;
		}

		.lampsSection {
			border-top: 1px solid white;
			display: grid;
			gap: 0px 0px;
			grid-auto-flow: row dense;
			grid-template-columns: 3fr 9fr;
			padding: 100px 0px;
			margin: 0 var(--large-padding);
		}

		.description {
			color: var(--color-grey4);
			font: var(--font-summary-paragraph);
			line-height: 22px;
			max-width: 70%;
			text-align: left;
		}

		.description h5 {
			color: var(--color-white);
			letter-spacing: 0.2;
		}

		.lampsGrid {
			display: block;
			max-width: 50%;
		}

		.lampContainer {
			margin: 0px 20px;
			position: relative;
		}

		.lampDescription {
			color: var(--color-grey4);
			font: var(--font-summary-paragraph);
			line-height: 22px;
		}

		.imgContainer {
			border-bottom: 1px solid #313131;
			text-align: center;
			width: 100%;
		}

		.imgContainer img {
		  	margin: auto;
			width: 100%;
		}

		.lampTitle {
			color: var(--color-white);
			font: var(--font-info-light);
			margin-top: -30px;
			position: absolute;
			text-transform: uppercase;
		}
		@media (max-width: 768px) {
			.lampsSection {
				display: block;
				padding: 0;
				margin: 0 var(--small-padding);
			}

			.description {
				max-width: 100%;
			}

			.lampsGrid {
				display: block;
				padding-right: 0px;
				max-width: 100%;
			}

			.lampContainer {
				margin: 35px 0px;
			}
			.imgContainer img {
				max-width: 60%;
			}
		 }

		`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.state = state;
		this.translations = state.productData.translations;
		this.decisions = state.decisions.data;
		this.profile = state.lightProfile.data.profile;
		this.lightProfile = state.lightProfile.data;
		this.productData = state.productData.productData;
		this.lang = state.status.lang;

	}
	getValueFromProductData(featureId, featureValueId) {
		const pd = getProductData(featureId, this.productData);
		return pd?.values?.find(val => val.valueId === featureValueId);
	}

	render() {
		const s = this.state;
		const lmo = luminaryOptions.find( luminaryOption =>  luminaryOption.id === this.lightProfile.project.luminary);
		const label = lmo ? lmo.label[this.lang] : '';
		const description = lmo ? lmo.description[this.lang] : '';
		let image = '';
		if (lmo.hasOwnProperty('imageModelSpecific')) {
			image = lmo ? lmo.imageModelSpecific[selectProductModelId(s)].image : '';
		} else {
			image = lmo ? lmo.image : '';
		}
		  return html`


		<section class="lampsSection">
			<div class="description">
				<h5>${msg('Your luminaire')}</h5>
				<p></p>
			</div>
			<div class="lampsGrid">
				<div class="lampContainer">
					<div class="imgContainer">
						<img src="${image}"/>
			 		 </div>
			 	 	<h4 class="lampTitle">${label}</h4>
			  		<p class="lampDescription">${description}</p>
				</div>
			</div>

		  </section>

		`;
	  }
}
